import { useSelector } from "react-redux";
import AggregatedFeed from "./AggregatedFeed";
import LiveStreamComponent from "./LiveStream Component/LiveStreamComponent";
import StoryPage from "./StoryPage";
import { memo } from "react";
import { Box } from "@mui/material";

const Home = memo(() => {
  const queryTextRedux = useSelector((state) => state.queryText.value);

  return (
    <Box id="home-news-container">
      <AggregatedFeed />
      {queryTextRedux ? <StoryPage /> : <LiveStreamComponent />}
    </Box>
  );
});

export default Home;
